var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-box"},[_c('img',{attrs:{"src":_vm.code}}),_c('div',{staticClass:"tip"},[_vm._v("扫描上方二维码进入阿克索健康小程序,点击体检报告解读上传体检报告")]),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.jump()}}},[_vm._v("点我直接进入小程序")])])
}
var staticRenderFns = []

export { render, staticRenderFns }